import React from 'react'

import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import useCheapestPropertyPricing from 'hooks/OfferPage/useCheapestPropertyPricing'
import { preventRenderWithOpenFilter } from 'lib/offer/offerPageUtil'
import {
  arePropertyRatesLoading,
  getPropertyCheapestRates,
  getPropertyRatesKey,
} from 'selectors/offerPage/offerPageSelectors'

import _BaseHotelFlightsToggleButton from './_BaseHotelFlightsToggleButton'
import { getSppPrices } from './utils'

interface Props {
  offer: App.HotelOffer
  areAnytimeRates: boolean
  shouldShowAnytimeRate: boolean
  isLoading: boolean
  cheapestPropertyRates: [App.PropertyRate | undefined, App.PropertyRate | undefined]
}

function SinglePropertyHotelFlightsToggleButton(props: Props) {
  const {
    offer,
    areAnytimeRates,
    shouldShowAnytimeRate,
    isLoading,
    cheapestPropertyRates,
  } = props

  /************************************************************************************************/
  /* STOP! Do not add any more hooks for deriving packages/rooms or options/rates to this         */
  /* component! This logic is being refactored out into selectors! If you _need_ to add new       */
  /* logic, speak to Xiao.                                                                        */
  /************************************************************************************************/

  const [hotelOnlyRate, hotelWithFlightsRate] = cheapestPropertyRates
  const [
    pricing,
    memberPricing,
    pricingWithFlights,
    memberPricingWithFlights,
  ] = useCheapestPropertyPricing()

  const hideAnytimePrices = areAnytimeRates && !shouldShowAnytimeRate
  const [hotelPrice, hotelMemberPrice, hotelFlightPrice] = hideAnytimePrices ? [0, 0, 0] : getSppPrices({
    hotelOnlyRate,
    hotelWithFlightsRate,
    pricing,
    memberPricing,
    pricingWithFlights,
    memberPricingWithFlights,
  })

  // Only show LuxPlus+ badging if the member price is _better_ than the non-member price.
  const showMemberPrice = !!hotelMemberPrice && hotelMemberPrice < hotelPrice
  const hotelTotalPrice = showMemberPrice ? hotelMemberPrice : hotelPrice

  // TODO: Checking these LPC offer flags isn't appropriate if we're dealing with an LPP rate.
  const flightsAvailable = offer.offerFlightsEnabled && !offer.flightCacheDisabled

  return <_BaseHotelFlightsToggleButton
    flightsAvailable={flightsAvailable}
    isMemberPrice={showMemberPrice}
    hotelTotalPrice={hotelTotalPrice}
    hotelFlightTotalPrice={hotelTotalPrice !== hotelFlightPrice ? hotelFlightPrice : undefined}
    pricesLoading={isLoading}
  />
}

export default withOfferPageAndReduxState((state, appState) => ({
  offer: state.offer as App.HotelOffer,
  areAnytimeRates: !getPropertyRatesKey(state, appState),
  // We only need to show anytime pricing for traffic coming from marketing, which will have
  // `utm_bp` set.
  shouldShowAnytimeRate: !!appState.utm.bp,
  isLoading: arePropertyRatesLoading(state, appState),
  cheapestPropertyRates: getPropertyCheapestRates(state, appState),
  open: !!state.activeFilter,
}), SinglePropertyHotelFlightsToggleButton, preventRenderWithOpenFilter)
